import { render, staticRenderFns } from "./ShortVideoNotify.vue?vue&type=template&id=49b08b3d&scoped=true"
import script from "./ShortVideoNotify.vue?vue&type=script&lang=js"
export * from "./ShortVideoNotify.vue?vue&type=script&lang=js"
import style0 from "./ShortVideoNotify.vue?vue&type=style&index=0&id=49b08b3d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49b08b3d",
  null
  
)

export default component.exports